module.exports = __webpack_public_path__ + "img/demo12.c304cc84.jpg";